

























































































































































































































































































































import dayjs from 'dayjs';
import { DialogPlugin } from 'tdesign-vue';
import {
  defineComponent,
  toRef,
  toRefs,
  Ref,
  onUnmounted,
  watch,
  ref,
  getCurrentInstance,
  computed,
} from '@vue/composition-api';
import { LinkIcon, LinkUnlinkIcon, HistoryIcon, EllipsisIcon } from 'tdesign-icons-vue';

// 引入组件
import linkShare from '@/renderer/components/dialog/linkShare/index.vue';
import RefreshableHeader from '@/renderer/components/SpacePage/components/RefreshableHeader.vue';
import HistoryList from '@/renderer/components/linkList/components/HistoryList.vue';
import i18n, { i18n_t } from '@/locales/i18n';

// 引入 compositions
import linkShareHandler, { LinkNameFilter } from '@/renderer/components/dialog/linkShare/composition/linkShareHandler';
import { drawerHandler } from '@/renderer/scripts/composition/drawerHandler';
import listOperateHandler from '@/renderer/scripts/composition/listOperateHandler';
import linkDownAndPreviewHandler from '@/renderer/components/linkList/compositions/linkDownAndPreviewHandler';
import linkDetailHandler, {
  BaseDetailType,
  DetailType,
} from '@/renderer/components/linkList/compositions/linkDetailHandler';
import { setResizableColumns } from '@/renderer/scripts/composition/tableResizeHandler';

// 引入工具类
import smh, { SMH } from '@/renderer/scripts/smh';
import tips, { MsgError } from '@/renderer/scripts/utils/tips';
import { DrawerEvents } from '@/renderer/store/modules/drawer';
import ipc from '@/renderer/scripts/utils/ipc';
import { getNameTipsDetail } from '@/renderer/scripts/utils/tools/index';
import CustomDialog from '@/renderer/scripts/utils/CustomDialog';
import { SEARCH_TYPE_MAP } from '@/renderer/scripts/utils/ConstantConfig/ConstantI18NConfig';
import linkListHandle from './compositions/linkListHandle';

export default defineComponent({
  props: {
    isConsole: {
      type: Boolean,
      default: false,
    },
    linkQueryParams: {
      type: Object,
      default: () => ({}),
    },
    hideHeader: {
      type: Boolean,
      default: false,
    },
  },
  filters: {
    LinkNameFilter,
    formatFileType(key: string) {
      const fileType: Record<string, string> = SEARCH_TYPE_MAP;
      return fileType[key] || key;
    },
  },
  components: { HistoryList, LinkIcon, LinkUnlinkIcon, HistoryIcon, EllipsisIcon, linkShare, RefreshableHeader },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const store = context.root.$store;
    const linkQueryParams = toRef(props, 'linkQueryParams') as Ref<SMH.OrgShareListParams>;
    const {
      columns,
      pageData,
      tableData,
      loading,
      loadingOnHeader,
      sort,
      methods: listMethods,
    } = linkListHandle(props.isConsole, linkQueryParams.value);
    const { show: showLink, viewData, methods: linkShareMethods } = linkShareHandler();
    const {
      operateShowMap,
      isFirstButtonHover,
      isSecondButtonHover,
      isThirdButtonHover,
      hoverIndex,
      isDropdownShow,
      methods: listOperateMethods,
    } = listOperateHandler(tableData);
    const { methods: linkDownAndPreview } = linkDownAndPreviewHandler();
    const { drawerHandlerMethods } = drawerHandler();
    const { methods: detailMethods, detailItem, show: showDetail, loading: detailLoading } = linkDetailHandler();
    const inGroupManage = computed(() => props.linkQueryParams.groupId !== undefined && props.isConsole);

    // 初始化的时候，立刻初始化详情组件
    const emptyScope: Drawer.EmptyScope = {
      title: '',
      componentName: 'EmptyDetail',
      params: {
        totalMsg: i18n_t('共有0个文件'),
        title: inGroupManage.value ? i18n_t('协作群组分享') : i18n_t('安全外链'),
        desc: inGroupManage.value ? i18n_t('所有成员分享链接可以在此看到') : i18n_t('批量大文件安全收发'),
        imgClass: '',
      },
    };
    if (!props.isConsole || inGroupManage.value) {
      drawerHandlerMethods.setDrawers([emptyScope]);
    }
    const showHistory = ref(false);
    const currentItem = ref<SMH.GetShareLinkData>();
    const itemOptions = computed(() => {
      const options: Array<{ content: string; value: string; iconName: string }> = [];
      options.push({ content: i18n_t('查看链接'), value: 'check', iconName: 'LinkIcon' });
      if (props.isConsole) {
        options.push({ content: i18n_t('访问记录'), value: 'history', iconName: 'HistoryIcon' });
        if (!inGroupManage.value) {
          options.push({ content: i18n_t('链接详情'), value: 'detail', iconName: 'LinkIcon' });
        }
      }
      options.push({ content: i18n_t('删除链接'), value: 'delete', iconName: 'LinkUnlinkIcon' });
      return options;
    });

    // 当数据全部加载完毕
    const setTotal = (total: number) => {
      store.commit(DrawerEvents.SET_TOTAL, total);
    };

    const genResizableColumns = () => {
      const resizableData = [
        {
          colKey: 'shareTraffic',
          resizable: true,
          minWidth: 120,
          maxWidth: 200,
        },
      ];

      return setResizableColumns(columns.value, resizableData);
    };

    const resizeColumns = ref(genResizableColumns());

    ipc.on(ipc.RENDERER_EVENTS_MAP.ON_DATA_LOADED, setTotal);
    const methods = {
      cancelLink(item: SMH.GetShareLinkData) {
        const deleteDialog = CustomDialog.confirm({
          header: i18n_t('提示'),
          body: i18n_t('是否删除链接？删除后将无法访问'),
          theme: 'warning',
          onConfirm: async () => {
            if (deleteDialog.hide) {
              deleteDialog.hide();
            }
            const id = item ? [item.id] : (tableData.selectedRowKeys as Array<number>);
            listMethods.cancelLink(id);
          },
        });
      },
      async viewLink(item: SMH.GetShareLinkData) {
        // if (item.disabled) return;
        try {
          const res = await smh.userAPI.getSharedLinkItem({
            shareId: item.id,
          });
          res.data.shareTraffic = item.shareTraffic;
          linkShareMethods.viewShare([
            {
              ...(res.data as SMH.GetSharedLinkItemData),
              type: item.type as string,
            },
          ]);
        } catch (error) {
          tips.error(error as MsgError);
        }
      },
      hasNoCount(item: SMH.GetShareLinkData, type: 'download' | 'preview') {
        const count = item[`${type}Count` as keyof SMH.GetShareLinkData];
        const countUsed = item[`${type}CountUsed` as keyof SMH.GetShareLinkData];
        return !!count && count === countUsed;
      },
      showHistoryView(item: SMH.GetShareLinkData) {
        showHistory.value = true;
        currentItem.value = item;
      },
      silentRefreshList() {
        if (!loading.value && !loadingOnHeader.value) {
          listMethods.silentRefresh();
        }
      },

      closeDetailInfo() {
        showDetail.value = false;
      },

      async handleOptionsClickEvent(command: string, item: SMH.GetShareLinkData) {
        methods.closeDetailInfo();
        switch (command) {
          case 'detail':
            await detailMethods.getLinkDetailData(item);
            detailMethods.openDetail();
            break;
          case 'delete':
            methods.cancelLink(item);
            break;
          case 'check':
            methods.viewLink(item);
            break;
          case 'history':
            methods.showHistoryView(item);
            break;
          default:
            break;
        }
      },
    };

    // 数据改变时的代码块;
    const selectedChangeFn = (selectedList: SMH.GetShareLinkData[]) => {
      if (props.isConsole && !inGroupManage.value) {
        return;
      }
      if (selectedList.length === 0 || selectedList.length > 1) {
        drawerHandlerMethods.setDrawers([emptyScope]);
      }
      if (selectedList.length === 1) {
        // 初始化的时候，立刻初始化详情组件
        const linkDetailScope: Drawer.LinkDetailScope<SMH.GetShareLinkData> = {
          title: i18n_t('详情'),
          componentName: 'LinkDetail',
          params: {
            selectedItem: selectedList[0],
          },
        };
        drawerHandlerMethods.setDrawers([linkDetailScope]);
      }
    };
    onUnmounted(() => {
      ipc.off(ipc.RENDERER_EVENTS_MAP.ON_DATA_LOADED, setTotal);
    });
    watch(
      () => tableData.selectedList,
      val => {
        selectedChangeFn(val as SMH.GetShareLinkData[]);
      },
    );

    return {
      linkDownAndPreview,
      currentItem,
      showHistory,
      operateShowMap,
      hoverIndex,
      isFirstButtonHover,
      isSecondButtonHover,
      isThirdButtonHover,
      listOperateMethods,
      resizeColumns,
      sort,
      loading,
      loadingOnHeader,
      ...toRefs(tableData),
      ...toRefs(pageData),
      ...methods,
      listMethods,
      showLink,
      viewData,
      linkShareMethods,
      dayjs,
      isDropdownShow,
      detailItem,
      showDetail,
      detailLoading,
      DetailType,
      BaseDetailType,
      getNameTipsDetail,
      itemOptions,
    };
  },
});
